module.exports = console;